/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AuditEventType = {
    UserLogon: 'UserLogon',
    CreateTaSubmission: 'CreateTaSubmission',
    SubmitTaSubmission: 'SubmitTaSubmission',
    ApprovalAction: 'ApprovalAction',
    SubmissionStatusChange: 'SubmissionStatusChange',
    TravelAcquitted: 'TravelAcquitted',
    JobStarted: 'JobStarted',
    JobCompleted: 'JobCompleted',
    JobFailed: 'JobFailed',
    UserDetailsChange: 'UserDetailsChange',
    FileEvent: 'FileEvent',
    Notification: 'Notification',
    NotificationFail: 'NotificationFail',
    SubmissionEdit: 'SubmissionEdit',
    ItineraryEdit: 'ItineraryEdit',
    DataChange: 'DataChange',
    UserLogout: 'UserLogout',
    ApplicationStarted: 'ApplicationStarted',
    CommentEvent: 'CommentEvent',
    CreateTaTemplate: 'CreateTaTemplate',
    DeleteTaTemplate: 'DeleteTaTemplate'
} as const;
export type AuditEventType = typeof AuditEventType[keyof typeof AuditEventType];

